"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _List = _interopRequireDefault(require("../List"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
var getTermFromHighlight = function getTermFromHighlight(highlight) {
  return highlight.replace(/(<em>)|(<\/em>)/g, '');
};
var Pages = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var pages = props.pages,
    groupId = props.groupId,
    assetId = props.assetId,
    version = props.version,
    onKeyDown = props.onKeyDown;
  var pagesFromStore = (0, _reactRedux.useSelector)(function (state) {
    return _exchangeUiPortalsStore.selectors.selectPages(state, {
      groupId: groupId,
      assetId: assetId,
      version: version,
      isDraft: false
    });
  });
  var groupedPages = _react.default.useMemo(function () {
    return pages.reduce(function (accum, current) {
      var _pagesFromStore$find$, _pagesFromStore$find;
      var existingPage = accum.find(function (item) {
        return item.title === current.title;
      });
      if (existingPage) {
        existingPage.pages.push(current);
        return accum;
      }
      return [].concat((0, _toConsumableArray2.default)(accum), [{
        title: current.title,
        path: (_pagesFromStore$find$ = (_pagesFromStore$find = pagesFromStore.find(function (page) {
          return page.name === current.title;
        })) === null || _pagesFromStore$find === void 0 ? void 0 : _pagesFromStore$find.path) !== null && _pagesFromStore$find$ !== void 0 ? _pagesFromStore$find$ : current.title,
        pages: [current]
      }]);
    }, []);
  }, [pages, pagesFromStore]);
  return /*#__PURE__*/_react.default.createElement(_List.default, {
    onKeyDown: onKeyDown,
    ref: ref,
    testId: "pages"
  }, groupedPages.map(function (group, index) {
    var title = group.path === 'home' ? 'Home' : getTermFromHighlight(group.title);
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      path: "/pages/".concat(group.path),
      title: title,
      key: index
    }, title);
  }));
});
var _default = exports.default = Pages;
//# sourceMappingURL=Pages.js.map